// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3SOP3","modalFooterButton":"ModalNotes_modalFooterButton__3A6jN"};